module.exports = __webpack_public_path__ + "static/img/1969.2bea15c7.jpg";